export default "__VITE_PUBLIC_ASSET__4b0beaf6__"